import type React from 'react';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useTooltip } from '@react-aria/tooltip';
import { mergeProps } from '@react-aria/utils';

import type { TooltipTriggerState } from '@react-stately/tooltip';

import TooltipContainer from './tooltip-container';

export type POSITION = 'TOP' | 'BOTTOM';

export interface IProps extends React.HTMLAttributes<HTMLElement> {
  activeTooltipTopCSS?: boolean;
  activeTooltipBottomCSS?: boolean;
  alignTriangle?: string;
  backgroundColor?: string;
  content?: string;
  icon: IconProp;
  iconClass?: string;
  marginTop?: number;
  marginRight?: number;
  marginBottom?: number;
  marginLeft?: number;
  position?: POSITION;
  state?: TooltipTriggerState;
  textColor?: string;
  title?: string;
  titleClass?: string;
  transform?: string;
  transformTriangle?: string;
  width?: string;
}

const Tooltip: React.FC<IProps> = (props) => {
  const {
    backgroundColor,
    alignTriangle,
    content,
    icon,
    iconClass = '',
    position,
    state,
    textColor = 'text-white',
    title,
    titleClass = '',
    width
  } = props;
  const { tooltipProps } = useTooltip(props, state);

  const displayIcon = <FontAwesomeIcon className={`mx-2 ${iconClass}`} icon={icon} />;
  const _content = <p className={`mx-3 mt-2 opacity-75 ${textColor}`}>{content}</p>;

  return (
    <TooltipContainer
      {...mergeProps(props, tooltipProps)}
      alignTriangle={alignTriangle}
      backgroundColor={backgroundColor}
      position={position}
      width={width}
    >
      {!!title ? (
        <div className="flex flex-row justify-start">
          <div className="mt-1 flex">{displayIcon}</div>
          <div className="flex flex-col">
            <span className={`font-bold ${titleClass} ${textColor}`}>{title}</span>
            {_content}
          </div>
        </div>
      ) : (
        <>
          {displayIcon}
          {_content}
        </>
      )}
    </TooltipContainer>
  );
};

export default Tooltip;
